/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Error_Key_Cap_ExceededInputs */

const en_usage_error_key_cap_exceeded = /** @type {(inputs: Usage_Error_Key_Cap_ExceededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key cap exceeded`)
};

const zh_hans1_usage_error_key_cap_exceeded = /** @type {(inputs: Usage_Error_Key_Cap_ExceededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已超出密钥额度上限`)
};

const pt_br2_usage_error_key_cap_exceeded = /** @type {(inputs: Usage_Error_Key_Cap_ExceededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite da chave excedido`)
};

const es_usage_error_key_cap_exceeded = /** @type {(inputs: Usage_Error_Key_Cap_ExceededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límite de la clave superado`)
};

const fr_usage_error_key_cap_exceeded = /** @type {(inputs: Usage_Error_Key_Cap_ExceededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plafond de la clé dépassé`)
};

const de_usage_error_key_cap_exceeded = /** @type {(inputs: Usage_Error_Key_Cap_ExceededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel-Limit überschritten`)
};

const ru_usage_error_key_cap_exceeded = /** @type {(inputs: Usage_Error_Key_Cap_ExceededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лимит ключа превышен`)
};

const it_usage_error_key_cap_exceeded = /** @type {(inputs: Usage_Error_Key_Cap_ExceededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite della chiave superato`)
};

/**
* | output |
* | --- |
* | "Key cap exceeded" |
*
* @param {Usage_Error_Key_Cap_ExceededInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const usage_error_key_cap_exceeded = /** @type {((inputs?: Usage_Error_Key_Cap_ExceededInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Error_Key_Cap_ExceededInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_usage_error_key_cap_exceeded(inputs)
	if (locale === "pt-BR") return pt_br2_usage_error_key_cap_exceeded(inputs)
	if (locale === "es") return es_usage_error_key_cap_exceeded(inputs)
	if (locale === "fr") return fr_usage_error_key_cap_exceeded(inputs)
	if (locale === "de") return de_usage_error_key_cap_exceeded(inputs)
	if (locale === "ru") return ru_usage_error_key_cap_exceeded(inputs)
	if (locale === "it") return it_usage_error_key_cap_exceeded(inputs)
	return en_usage_error_key_cap_exceeded(inputs)
});